export default "__VITE_ASSET__904a6b8e__"